import { inject, Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Option } from '@core/models/Option';
import { HttpClientService } from "@core/services/http-client.service";
import { BillingDetail } from "@core/models/BllingDetail";
import { JsonFormatterService } from "./common/json-formatter.service";

@Injectable({
  providedIn: 'root',
})
export class BookingService {
  private httpClientService = inject(HttpClientService);
  private jsonFormmater = inject(JsonFormatterService);

  public saveAsTemplate$(bookResearchRequest: FormGroup,templateName: string) {
    const sanatizedTemplate = this.prepareTemplate(bookResearchRequest,templateName);
    return this.httpClientService.post(sanatizedTemplate, 'BookingDashboard/templates');
  }

  private prepareTemplate(booking:FormGroup, templateName: string): any{
    const processedData = {
      coordinator: booking.get('coordinator')?.getRawValue(),
      contactDetail: booking.get('contactDetail')?.getRawValue(),
      billingDetail: booking.get('billingDetail')?.getRawValue() ?? new BillingDetail().getRawValue(),
      name: templateName,
    };

    let { billingDetail } = processedData;
    if (billingDetail?.poNumberNotRequired) {
      delete billingDetail.poNumber;
    }
    if (billingDetail?.jobNumberNotRequired) {
      delete billingDetail.jobNumber;
    }
    return this.jsonFormmater.cleanData(processedData);
  }

  createOptionsFromArray(array: string[]) {
    return array.map(item => { return new Option(item, item) })
  }

  createIndexedOptionsFromArray(array: string[]) {
    return array.map((item, index) => { return new Option(String(index + 1), item) })
  }
}
